import router from '@/router';

// 判断是否叶子节点
const isLeaf = (data, prop) => !(Array.isArray(data[prop]) && data[prop].length > 0);

// 创建 node 节点
export const renderNode = (h, data, context) => {
  const { props } = context;
  const cls = ['org-tree-node'];
  const childNodes = [];
  const children = data[props.props.children];
  if (isLeaf(data, props.props.children)) {
    cls.push('is-leaf');
  }
  if (
    props.collapsable &&
    !data[props.props.expand] &&
    !isLeaf(data, props.props.children) &&
    (data.type !== 'emp' || router.history.current.name === 'orgRelationShip')
  ) {
    cls.push('collapsed');
  }
  if ('virtual' in data && data.virtual) {
  } else {
    childNodes.push(renderLabel(h, data, context));
  }

  if (!props.collapsable || data[props.props.expand]) {
    childNodes.push(renderChildren(h, children, context, data));
  }

  if (data.parentNode) {
    const vir = 'virtual';
    const flag = vir in data.parentNode;
    return h('div', {
      domProps: {
        className: cls.join(' '),
        id: flag ? 'org-tree-node' : '',
      },
    }, childNodes);
  }
  return h('div', {
    domProps: {
      className: cls.join(' '),
    },
  }, childNodes);
};

// 创建展开子节点折叠按钮
export const renderBtn = (h, data, context) => {
  const { props } = context;
  const expandHandler = context.listeners['on-expand'];

  const cls = ['org-tree-node-btn'];
  if (data[props.props.expand]) {
    cls.push('expanded');
  }

  return h('span', {
    domProps: {
      className: cls.join(' '),
    },
    on: {
      click: (e) => {
        e.stopPropagation();
        expandHandler && expandHandler(data);
      },
    },
  }, [
    h('span', {
      domProps: {
        className: 'btn-wrapper',
      },
    }),
    h('span', {
      domProps: {
        className: 'btn-sx',
      },
    }),
  ]);
};
// 创建展开父节点折叠按钮
export const renderTopBtn = (h, data, context) => {
  const { props } = context;
  const expandHandler = context.listeners['on-hidden'];
  const cls = ['org-tree-node-btn', 'parent-dom'];
  if (data[props.props.hidden] || (!data.is_top && data.parentNode && 'virtual' in data.parentNode)) {
    cls.push('parent-hidden');
  }

  return h('span', {
    domProps: {
      className: cls.join(' '),
    },
    on: {
      click: (e) => {
        e.stopPropagation();
        expandHandler && expandHandler(data);
      },
    },
  }, [
    h('span', {
      domProps: {
        className: 'btn-wrapper',
      },
    }),
    h('span', {
      domProps: {
        className: 'btn-icon',
      },
    }),
  ]);
};
// 创建 label 节点
export const renderLabel = (h, data, context) => {
  const { props } = context;
  const label = data[props.props.label];
  const { renderContent } = props;
  const clickHandler = context.listeners['on-node-click'];
  const childNodes = [];
  if(!data.isNoSelect) childNodes.push(select(h, data, context));
  if (typeof renderContent === 'function') {
    const vnode = renderContent(h, data);
    vnode && childNodes.push(vnode);
  } else {
    childNodes.push(label);
  }
  if (
    data.parentNode
    && !('virtual' in data.parentNode)
    && 'parentHidden' in data
    && data.parentHidden === true
  ) {
    childNodes.push(renderTopBtn(h, data, context))
  }

  if (
    props.collapsable &&
    !isLeaf(data, props.props.children) &&
    (data.parentNode && data.parentNode.type !== 'job')
  ) {
    childNodes.push(renderBtn(h, data, context));
  } else if (
    !isLeaf(data, props.props.children) &&
    (data.parentNode && data.parentNode.type !== 'job')
  ) {
    childNodes.push(renderBtn(h, data, context));
  }

  const cls = ['org-tree-node-label-inner'];
  if (data.is_dot_line) {
    cls.push('dot-solid-line');
  }
  if (data.search) {
    cls.push('box-shown-node')
  }
  let { labelWidth, labelClassName } = props;
  if (typeof labelWidth === 'number') {
    labelWidth += 'px';
  }
  if (typeof labelClassName === 'function') {
    labelClassName = labelClassName(data);
  }
  labelClassName && cls.push(labelClassName);
  let id = 'id';
  if (data.emp_id) id = data.emp_id;
  if (data.job_id) id = data.job_id;
  if (data.org_id) id = data.org_id;
  return h('div', {
    domProps: {
      className: 'org-tree-node-label',
      id: 'org-tree-node-' + id,
    },
  }, [h('div', {
    domProps: {
      className: cls.join(' '),
    },
    style: { width: labelWidth },
    on: {
      click: e => clickHandler && clickHandler(e, data),
    },
  }, childNodes)]);
};

// 创建 node 子节点
export const renderChildren = (h, list, context, data) => {
  if (Array.isArray(list) && list.length) {
    const children = list.map((item) => {
      item.parentNode = data;
      return renderNode(h, item, context);
    });
    if ('virtual' in data && data.virtual) {
      return h('div', {
        domProps: {
          className: 'org-tree-node-children',
          id: 'org-tree-node-children',
        },
      }, children);
    }
    return h('div', {
      domProps: {
        className: 'org-tree-node-children',
      },
    }, children);
  }
  return '';
};
// 添加单选框
// 单选框
export const select = (h, data, context) => {
  const { props } = context;
  const expandHandler = context.listeners['on-change'];
  const cls = ['select'];
  if(context.props.select){
    return h('div', {
      domProps: {
        className: cls.join(' '),
      },
    }, [
      h('input', {
        domProps: {
          type: 'radio',
          name: 'L001',
          className: 'change',
          dataV: false
        },
        on: {
          click: (e) =>{
            e.currentTarget.checked = !e.currentTarget.dataV
            e.currentTarget.dataV = !e.currentTarget.dataV
            expandHandler && expandHandler(data, e.currentTarget.dataV);
          },
          change: (e) => {
            e.stopPropagation();
          },
        },
      }),
    ]);
  }
};

export const render = (h, context) => {
  const { props } = context;
  return renderNode(h, props.data, context);
};

export default render;
